/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import { Animated } from "react-animated-css";

/* Helpers, constants, custom methods, internal libraries */
/* Components */
import {ReactComponent as NotificationOkIcon} from "../../resources/images/icon-notification-ok.svg";
import {ReactComponent as NotificationErrorIcon} from "../../resources/images/icon-notification-error.svg";
import {ReactComponent as NotificationDangerIcon} from "../../resources/images/icon-notification-danger.svg";
import {ReactComponent as NotificationCloseIcon} from "../../resources/images/icon-notification-close.svg";

/* Styles */
import styles from "./styles.js"


const Notification = (props) => {
  const { children, type, removeNotification, title, text, rest} = props;

  const theme = useTheme();
  const classes = styles({ theme });
  const [notifVisible, setNotifVisible] = useState(true);

  useEffect(() => {
    if (type === "refresh") return;

    const hideTimeout = setTimeout(() => {
      setNotifVisible(false);
    }, rest.dismissTime ? rest.dismissTime : 3000);

    const removeTimeout = setTimeout(() => {
      removeNotification();
    }, rest.dismissTime ? rest.dismissTime + 300 : 3300);

    return () => {
      clearTimeout(hideTimeout);
      clearTimeout(removeTimeout);
    };
  }, [type, rest.dismissTime]);

  const getIcon = () => {
    switch (type) {
      case "success":
        return <NotificationOkIcon className={classes.icon} />
      case "error":
      case "refresh":
        return <NotificationErrorIcon className={classes.icon} />
      case "danger":
        return <NotificationDangerIcon className={classes.icon} />
    }
  }

  const refreshPage = () => {
    window.location.reload(true);
  }

  return (
    <Animated
      animationIn="slideInRight"
      animationOut="slideOutRight"
      animationOutDuration={200}
      animationInDuration={200}
      isVisible={notifVisible}
    >
      <div className={classes.notification}>
        <div className={classes.notificationWrapper}>
          {getIcon()}
          <div className={classes.notificationContainer}>
            <div className={classes.iconContainer}>
              <div className={classes.notificationTitle}>{title}</div>
              <div className={classes.notificationText}>{text}</div>
              {type === 'refresh' ? (
                <div className={classes.notificationDismiss} onClick={refreshPage}>
                  <FormattedMessage id="notifications.refresh" />
                </div>
              ) : (
                <div className={classes.notificationDismiss} onClick={removeNotification} tabIndex={0}>
                  <FormattedMessage id="notifications.dismiss" />
                </div>
              )}
            </div>
            <div>
              <NotificationCloseIcon className={classes.closeIcon} onClick={removeNotification} tabIndex={0}/>
            </div>
          </div>
        </div>
      </div>
    </Animated>
  );
}

export default Notification;
